import React, { Component } from 'react';
import { FiCast, FiLayers, FiUsers, FiMonitor } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import { FaFonticons } from 'react-icons/fa';

const ServiceList = [
	{
		key: '/movingguide',
		icon: <img src={require('../../../assets/icon1.jpeg')} />,
		title: 'Moving Guide',
		description: 'Are you faced with your first relocation? Then it’s not a surprise that you’re so confused and you have no idea what to do. Don’t worry because this simple moving guide is all you need to deal successfully with your removals.',
		description2:
			'It’s not a good idea to start packing your belongings if you haven’t organized your move. Making a plan is the first thing that would help you deal with problems and make sure that your relocation will pass smoothly. All experts from moving company Victoria recommend writing on a piece of paper all your tasks and making a schedule who should take care of them and, of course, when. Hang it on the fridge or somewhere else where everyone could see it and make sure that all members of your family',
		styleShadow: 'boxShadow: -5px 5px 10px 15px ',
	},
	{
		key: '/movingtips',
		icon: <img src={require('../../../assets/icon2.jpeg')} />,
		title: 'Moving Packing Tips',
		description:
			'Most people consider moving an absolute nightmare. But it doesn"t have to be. Planning ahead and doing things the right way can make your life a lot easier and make sure that your belongings get safely. The following packing tips are designed to help make your move as stress-free as possible.',
		description2:
			'Many moving companies like Moonline moving offer a packing service, and some people assume that having someone else take care of the boxes and bubble wrap will lessen their stress. However, if you have the time and you begin far enough in advance, you can make things a lot simpler by packing up your own belongings. That way, you can make sure the valuables are well-wrapped, and best of all, you"ll know where everything is.',
		styleShadow: 'boxShadow: 5px 5px 10px 15px ',
	},
];
class AboutTwo extends Component {
	render() {
		const { column } = this.props;
		const ServiceContent = ServiceList.slice(0, this.props.item);
		return (
			<React.Fragment>
				<div className='row'>
					<div className={`${column}`}>
						<div className='service' style={{ padding: '50px', borderRadius: '25px', boxShadow: '-15px 10px 35px -5px grey' }}>
							<div className='icon' style={{ fontSize: '40px', textAlign: 'center' }}>
								<img src={require('../../../assets/icon1.jpeg')} />
							</div>
							<div className='content'>
								<h3 className='title'>Moving Guide</h3>
								<p>Are you faced with your first relocation? Then it’s not a surprise that you’re so confused and you have no idea what to do. Don’t worry because this simple moving guide is all you need to deal successfully with your removals.</p>
								<p>
									It’s not a good idea to start packing your belongings if you haven’t organized your move. Making a plan is the first thing that would help you deal with problems and make sure that your relocation will pass smoothly. All experts from moving company Victoria
									recommend writing on a piece of paper all your tasks and making a schedule who should take care of them and, of course, when. Hang it on the fridge or somewhere else where everyone could see it and make sure that all members of your family
									<a id='ReadMore' href='/movingguide'>
										{' '}
										... Read More
									</a>
								</p>
							</div>
							<div className='text-right'></div>
						</div>
					</div>
					<div className={`${column}`}>
						<div className='service' style={{ padding: '50px', borderRadius: '25px', boxShadow: '15px 5px 35px -5px grey' }}>
							<div className='icon' style={{ fontSize: '40px', textAlign: 'center' }}>
								<img src={require('../../../assets/icon2.jpeg')} />
							</div>
							<div className='content'>
								<h3 className='title'>Moving Packing Tips</h3>
								<p>
									Most people consider moving an absolute nightmare. But it doesn"t have to be. Planning ahead and doing things the right way can make your life a lot easier and make sure that your belongings get safely. The following packing tips are designed to help make your
									move as stress-free as possible.
								</p>
								<p>
									Many moving companies like Moonline moving offer a packing service, and some people assume that having someone else take care of the boxes and bubble wrap will lessen their stress. However, if you have the time and you begin far enough in advance, you can make
									things a lot simpler by packing up your own belongings. That way, you can make sure the valuables are well-wrapped, and best of all, you"ll know where everything is.
									<a id='ReadMore' href='/movingtips'>... Read More</a>
								</p>
							</div>
							<div className='text-right'>
								{/* <button id='ReadMore' style={{ width: '140px', height: '40px', borderRadius: '5px' }}>
								</button> */}
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
export default AboutTwo;
